
import { mapGetters } from 'vuex';
import { formatPrice } from '@/modules/Helpers';

export default {
    props: {
        serviceFee: { type: [Number, String], required: true },
    },
    computed: {
        ...mapGetters(['vat']),
    },
    methods: {
        formatPrice,
        calcPrice (price) {
            return formatPrice(price);
        }
    },

}
